export const questionValidationText = {
  QUESTION_NULL: 'Question is Null',
  SOLUTION_NULL: 'Solution is Null',
  QUESTION_IMG_INVALID: 'Question Image Url is Invalid',
  SOLUTION_IMG_INVALID: 'Solution Image Url is Invalid',
  CONCEPT_NULL: 'Concept (L3) is Null',
  CONCEPT_INVALID: 'Concept (L3) is Invalid',
  DIFFICULTY_INVALID:
    'Difficulty Level is Invalid (allowed vales: { easy | medium | hard })',
};
